import Button from 'components/Button';
import Modal from 'components/Modal';
import TooltipWrapper from 'components/Tooltip';
import {FC, useState} from 'react';
import {useBackend} from 'state/backend';
import {c, t} from 'ttag';

import useDeleteApprovalFlow from '../../services';
import {BackendData} from '../../types';

const ModalFlowDelete: FC<{mid: string}> = ({mid}) => {
    const {data, refreshData} = useBackend<BackendData>();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const apiDelete = useDeleteApprovalFlow();
    const handleDelete = async () => {
        await apiDelete
            .mutateAsync({
                mid: mid,
                partnerMid: data.partnerMid,
            })
            .then(async () => {
                await refreshData(window.Urls.approval_settings_view());
                setIsModalOpen(false);
            });
    };
    return (
        <>
            <TooltipWrapper
                message={data.permissions.canCreateApproval.failureReason}
            >
                <Button
                    data-testid="delete"
                    disabled={!data.permissions.canCreateApproval.allowed}
                    icon="trash"
                    kind="secondary"
                    onClick={() => setIsModalOpen(true)}
                    size="xs"
                />
            </TooltipWrapper>
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <Modal.Body>
                    <p data-testid="delete-confirmation">{c('approval-settings')
                        .t`Are you sure you want to delete this approval flow?`}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Modal.Button
                        kind="secondary"
                        onClick={() => setIsModalOpen(false)}
                        size="sm"
                        type="cancel"
                    >
                        {t`Cancel`}
                    </Modal.Button>
                    <Modal.Button
                        kind="destructive"
                        onClick={handleDelete}
                        size="sm"
                        type="submit"
                    >
                        {t`Delete`}
                    </Modal.Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalFlowDelete;
